import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/Logo-Wide.png';
import marketvendrdirectLogo from '../assets/marketvendrdirect.webp';
import { useWebsiteContent } from '../hooks/useWebsiteContent';
import './Header.css';

const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL || '';
const MARKETVENDR_DIRECT_URL = 'https://marketvendrdirect.com/';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { content: websiteContent } = useWebsiteContent('website');

  const isActive = (path) => location.pathname === path;
  const loginHref = DASHBOARD_URL ? `${DASHBOARD_URL.replace(/\/$/, '')}/login` : null;
  const showMarketVendrDirectLogo = websiteContent?.show_marketvendrdirect_logo === 'true';

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <img src={logo} alt="MarketVendr Logo" className="logo-image" />
        </Link>
        
        <button 
          className="menu-toggle"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <Link 
            to="/" 
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className={`nav-link ${isActive('/about') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            About Us
          </Link>
          <Link 
            to="/vendrs" 
            className={`nav-link ${isActive('/vendrs') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Vendrs
          </Link>
          <Link 
            to="/contact" 
            className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Contact Us
          </Link>
          {showMarketVendrDirectLogo && (
            <a
              href={MARKETVENDR_DIRECT_URL}
              className="header-marketvendrdirect-link"
              onClick={() => setIsMenuOpen(false)}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="MarketVendrDirect - opens in new tab"
            >
              <img
                src={marketvendrdirectLogo}
                alt="MarketVendrDirect"
                className="header-marketvendrdirect-logo"
              />
            </a>
          )}
          {loginHref && (
            <a
              href={loginHref}
              className="nav-link nav-link--login"
              onClick={() => setIsMenuOpen(false)}
              target="_blank"
              rel="noopener noreferrer"
            >
              Vendr Login
            </a>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;

